/* global bz_app */
import template from './bz_loading_widget.html'

bz_app.component('bzLoadingWidget', { template })
